import { render, staticRenderFns } from "./EditPartnerMarketModal.vue?vue&type=template&id=131094d6&"
import script from "./EditPartnerMarketModal.vue?vue&type=script&lang=js&"
export * from "./EditPartnerMarketModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports